import { render, staticRenderFns } from "./SnippetEditor.vue?vue&type=template&id=c906c182"
import script from "./SnippetEditor.vue?vue&type=script&lang=js"
export * from "./SnippetEditor.vue?vue&type=script&lang=js"
import style0 from "./SnippetEditor.vue?vue&type=style&index=0&id=c906c182&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports